import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  setConfigPageSizeStationMunicipalities,
  setConfigPageStationMunicipalities,
  setConfigSortedStationMunicipalities,
  setConfigFilterStationMunicipalities,
} from "redux/actions/stationMunicipalities/stationMunicipalitiesActions";


export const useTableStationMunicipalitiesConfig = () => {
  const dispatch = useDispatch()
  
  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilterStationMunicipalities(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSortedStationMunicipalities(e));
  }, []);

  const handlePage = useCallback((e) => {
    dispatch(setConfigPageStationMunicipalities(e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageSizeStationMunicipalities(e));
  }, []);


  return {
    handleFilter, handleSort, handlePage, handlePageSize
  }
}